module.exports = __webpack_public_path__ + "static/media/shop-selected.fd716bb7.svg";